(function (globalScope, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (globalScope) globalScope.CernirCustomStrapPreconfiguration = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const DATA = Object.freeze({
  "version": "demo-v1.0.0",
  "defaultCategory": "exotic-leather",
  "customTypes": [
    {
      "id": "MTO",
      "label": "Made-to-Order"
    },
    {
      "id": "Bespoke",
      "label": "Bespoke"
    }
  ],
  "configuratorAccess": {
    "MTO": "complete",
    "Bespoke": "complete",
    "restrictedFields": []
  },
  "categories": [
    {
      "id": "exotic-leather",
      "label": "Exotic Leather"
    },
    {
      "id": "regular-leather",
      "label": "Regular Leather"
    },
    {
      "id": "non-leather",
      "label": "Non Leather"
    }
  ],
  "materials": [
    {
      "id": "alligator",
      "label": "Alligator Leather",
      "category": "exotic-leather",
      "basePriceCents": 14500,
      "colourInventory": [
        {
          "id": "brown",
          "label": "Brown"
        },
        {
          "id": "blue",
          "label": "Blue"
        },
        {
          "id": "black",
          "label": "Black"
        },
        {
          "id": "burgundy",
          "label": "Burgundy"
        },
        {
          "id": "green",
          "label": "Green"
        },
        {
          "id": "grey",
          "label": "Grey"
        },
        {
          "id": "navy",
          "label": "Navy"
        },
        {
          "id": "ocean-blue",
          "label": "Ocean Blue"
        },
        {
          "id": "olive-green",
          "label": "Olive Green"
        }
      ]
    },
    {
      "id": "alligator-round-scales",
      "label": "Alligator Round Scales",
      "category": "exotic-leather",
      "basePriceCents": 14500,
      "colourInventory": [
        { "id": "black", "label": "Black" },
        { "id": "ocean-blue", "label": "Ocean Blue" },
        { "id": "navy", "label": "Navy" },
        { "id": "green", "label": "Green" }
      ]
    },
    {
      "id": "ostrich-leg",
      "label": "Ostrich Leg Leather",
      "category": "exotic-leather",
      "basePriceCents": 12500,
      "colourInventory": [
        {
          "id": "dark-green",
          "label": "Dark Green"
        },
        {
          "id": "blue",
          "label": "Blue"
        },
        {
          "id": "brown",
          "label": "Brown"
        },
        {
          "id": "chartreuse-green",
          "label": "Chartreuse Green"
        },
        {
          "id": "copper",
          "label": "Copper"
        }
      ]
    },
    {
      "id": "alran-chevre",
      "label": "Alran Chevre Leather",
      "category": "regular-leather",
      "basePriceCents": 7500,
      "colourInventory": [
        {
          "id": "black",
          "label": "Black"
        },
        {
          "id": "taupe",
          "label": "Taupe"
        },
        {
          "id": "navy-blue",
          "label": "Navy Blue"
        },
        {
          "id": "red",
          "label": "Red"
        },
        {
          "id": "golden-brown",
          "label": "Golden Brown"
        },
        {
          "id": "bordeaux",
          "label": "Bordeaux"
        },
        {
          "id": "burgundy",
          "label": "Burgundy"
        },
        {
          "id": "grey",
          "label": "Grey"
        },
        {
          "id": "white",
          "label": "White"
        },
        {
          "id": "light-grey",
          "label": "Light Grey"
        }
      ]
    },
    {
      "id": "babele",
      "label": "Babele Leather",
      "category": "regular-leather",
      "basePriceCents": 7500,
      "colourInventory": [
        {
          "id": "grey",
          "label": "Grey"
        },
        {
          "id": "dark-brown",
          "label": "Dark Brown"
        },
        {
          "id": "denim-blue",
          "label": "Denim Blue"
        }
      ]
    },
    {
      "id": "buttero",
      "label": "Buttero Leather",
      "category": "regular-leather",
      "basePriceCents": 7500,
      "colourInventory": [
        {
          "id": "olive-green",
          "label": "Olive Green"
        },
        {
          "id": "brown",
          "label": "Brown"
        },
        {
          "id": "taupe",
          "label": "Taupe"
        },
        {
          "id": "tan",
          "label": "Tan"
        },
        {
          "id": "blue",
          "label": "Blue"
        }
      ]
    },
    {
      "id": "epsom",
      "label": "Epsom Leather",
      "category": "regular-leather",
      "basePriceCents": 7500,
      "colourInventory": [
        {
          "id": "golden-brown",
          "label": "Golden Brown"
        },
        {
          "id": "navy",
          "label": "Navy"
        },
        {
          "id": "black",
          "label": "Black"
        },
        {
          "id": "taupe",
          "label": "Taupe"
        },
        {
          "id": "dark-navy",
          "label": "Dark Navy"
        },
        {
          "id": "olive-green",
          "label": "Olive Green"
        },
        {
          "id": "tan",
          "label": "Tan"
        },
        {
          "id": "orange",
          "label": "Orange"
        },
        {
          "id": "pistachio-green",
          "label": "Pistachio Green"
        },
        {
          "id": "coral-red",
          "label": "Coral Red"
        },
        {
          "id": "grey",
          "label": "Grey"
        },
        {
          "id": "lemon-yellow",
          "label": "Lemon Yellow"
        },
        {
          "id": "petrol-blue",
          "label": "Petrol Blue"
        },
        {
          "id": "camel",
          "label": "Camel"
        }
      ]
    },
    {
      "id": "pueblo",
      "label": "Pueblo Leather",
      "category": "regular-leather",
      "basePriceCents": 7500,
      "colourInventory": [
        {
          "id": "turquoise",
          "label": "Turquoise"
        },
        {
          "id": "dark-brown",
          "label": "Dark Brown"
        },
        {
          "id": "rust-brown",
          "label": "Rust Brown"
        },
        {
          "id": "cognac",
          "label": "Cognac"
        },
        {
          "id": "olive",
          "label": "Olive"
        },
        {
          "id": "navy",
          "label": "Navy"
        }
      ]
    },
    {
      "id": "saffiano",
      "label": "Saffiano Leather",
      "category": "regular-leather",
      "basePriceCents": 7500,
      "colourInventory": [
        {
          "id": "blue",
          "label": "Blue"
        },
        {
          "id": "dusty-blue",
          "label": "Dusty Blue"
        },
        {
          "id": "black",
          "label": "Black"
        },
        {
          "id": "red",
          "label": "Red"
        },
        {
          "id": "grey",
          "label": "Grey"
        },
        {
          "id": "blue-camo",
          "label": "Blue Camo"
        },
        {
          "id": "denim-blue",
          "label": "Denim Blue"
        },
        {
          "id": "forest-green",
          "label": "Forest Green"
        },
        {
          "id": "mustard-yellow",
          "label": "Mustard Yellow"
        },
        {
          "id": "orange",
          "label": "Orange"
        },
        {
          "id": "taupe",
          "label": "Taupe"
        }
      ]
    },
    {
      "id": "shell-cordovan",
      "label": "Shell Cordovan Leather",
      "category": "regular-leather",
      "basePriceCents": 7500,
      "colourInventory": [
        {
          "id": "black",
          "label": "Black"
        },
        {
          "id": "burgundy",
          "label": "Burgundy"
        },
        {
          "id": "cognac",
          "label": "Cognac"
        },
        {
          "id": "natural",
          "label": "Natural"
        },
        {
          "id": "navy",
          "label": "Navy"
        }
      ]
    },
    {
      "id": "togo",
      "label": "Togo Leather",
      "category": "regular-leather",
      "basePriceCents": 7500,
      "colourInventory": [
        {
          "id": "taupe",
          "label": "Taupe"
        },
        {
          "id": "navy-blue",
          "label": "Navy Blue"
        },
        {
          "id": "golden-brown",
          "label": "Golden Brown"
        },
        {
          "id": "black",
          "label": "Black"
        },
        {
          "id": "tan",
          "label": "Tan"
        },
        {
          "id": "grey",
          "label": "Grey"
        },
        {
          "id": "beige",
          "label": "Beige"
        }
      ]
    }
  ]
});

  const materialsById = new Map(DATA.materials.map((material) => [material.id, material]));

  function getMaterials(categoryId) {
    return DATA.materials.filter((material) => material.category === categoryId);
  }

  function getMaterial(materialId) {
    return materialsById.get(materialId) || null;
  }

  function getColours(materialId) {
    return getMaterial(materialId)?.colourInventory || [];
  }

  function isMaterialInCategory(materialId, categoryId) {
    return getMaterial(materialId)?.category === categoryId;
  }

  function isColourForMaterial(colourId, materialId) {
    return getColours(materialId).some((colour) => colour.id === colourId);
  }

  function transition(rawState, stateApi, field, value) {
    let next = stateApi.updateRawState(rawState, field, value);

    if (['materialCategory', 'material', 'materialColour'].includes(field)) {
      next = stateApi.updateRawState(next, 'edgeColour', 'on-tone');
    }

    if (field === 'materialCategory' && !isMaterialInCategory(next.material, value)) {
      next = stateApi.updateRawState(next, 'material', null);
      next = stateApi.updateRawState(next, 'materialColour', null);
    }

    if (field === 'material') {
      const firstColour = getColours(value)[0]?.id || null;
      next = stateApi.updateRawState(next, 'materialColour', firstColour);
    }

    if (field === 'materialColour' && !isColourForMaterial(value, next.material)) {
      next = stateApi.updateRawState(next, 'materialColour', null);
    }

    return next;
  }

  return Object.freeze({
    DATA,
    getMaterials,
    getMaterial,
    getColours,
    isMaterialInCategory,
    isColourForMaterial,
    transition
  });
});
